/**
 * Status domain query keys (Server-state rebuild, P2).
 *
 * Fixes a real cascade bug in the legacy `QK.status`: it put the constant segment BEFORE
 * the auditId (`['status','tasks',id]`), so `['status', id]` was not a prefix of the tasks
 * key and invalidating the overview could never cascade to tasks/presets — which is why
 * every status mutation had to list all three keys by hand. Here the id precedes the
 * constant, so `statusKeys.all(id)` is a strict prefix of every child and one invalidation
 * cascades to overview + tasks + presets.
 */
/** Root segment for the socket backlinks predicate (`useSyncAuditData`). */
export const STATUS_TASK_BACKLINKS_ROOT = 'status-task-backlinks';

export const statusKeys = {
  all: (auditId?: string) => ['status', auditId] as const,
  /** The status board / overview (legacy name: `base`). */
  overview: (auditId?: string) => [...statusKeys.all(auditId), 'overview'] as const,
  tasks: (auditId?: string) => [...statusKeys.all(auditId), 'tasks'] as const,
  presets: (auditId?: string) => [...statusKeys.all(auditId), 'presets'] as const,

  // ── task backlinks (own root, deliberate) ───────────────────────────────
  /**
   * `GET /status/steps/{stepId}/backlinks` (0.54.0, auditor role only) — the places
   * that cite this task. Off `all(auditId)` on purpose: every board save invalidates
   * that prefix, and the reference scan must not ride along with it.
   */
  taskBacklinksRoot: () => [STATUS_TASK_BACKLINKS_ROOT] as const,
  taskBacklinks: (auditId?: string, stepId?: string | number) =>
    [STATUS_TASK_BACKLINKS_ROOT, auditId, String(stepId)] as const,
} as const;
